import store from "@/store";

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Painel',
        to: '/inicio',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Histórico',
        to: '/operacoes/lista',
        icon: 'cil-history',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Estatísticas',
        to: '/estatisticas',
        icon: 'cil-chartPie',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Tarefas',
        to: '/tarefas/lista',
        icon: 'cil-task',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Ferramentas',
        to: '/ferramentas/lista',
        icon: 'cil-pen-nib',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Locais',
        to: '/locais/lista',
        icon: 'cil-location-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Recursos Humanos',
        to: '/pessoas/lista',
        icon: 'cil-user',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Definições',
        to: '/definicoes',
        icon: 'cil-settings',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Terminar Sessão',
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]